import { render, staticRenderFns } from "./TableUnassignedPetitions.vue?vue&type=template&id=21d0d227"
import script from "./TableUnassignedPetitions.vue?vue&type=script&lang=js"
export * from "./TableUnassignedPetitions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports